




























































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import Rule from '@/apps/website/parts/Rule/index.vue'

@Component({
  components: {
    Rule
  }
})
export default class UserAgrrent extends Vue {
  @Prop()
  private openUserAgreement!: Function
  private localVisible: boolean = false
  public openComponent() {
    this.localVisible = true
  }
  get isMobile() {
    return document.body.clientWidth <= 800
  }
  shutDown() {
    this.localVisible = false
  }
  cancel() {}
}
